import { Box, Typography } from '@mui/material';
import { useResponsive } from '@/components/hooks/useResponsive';
import { CaregiverHireCount } from './CaregiverHireCount';

interface CaregiverExperienceInfoProps {
  yearsOfExperience: number;
  hiredTimes: number;
}

export const CaregiverExperienceInfo = ({
  yearsOfExperience,
  hiredTimes,
}: CaregiverExperienceInfoProps) => {
  const { isSmallViewport } = useResponsive();

  return (
    <Box display="flex" alignItems="center" columnGap={1}>
      <Typography component="span" variant={isSmallViewport ? 'body3' : 'body2'}>
        {`${yearsOfExperience} ${yearsOfExperience === 1 ? 'year' : 'years'} experience`}
      </Typography>
      {!isSmallViewport && (
        <>
          {yearsOfExperience > 0 && hiredTimes > 0 && (
            <Box fontSize="36px" component="span">
              &middot;
            </Box>
          )}
          {hiredTimes > 0 && <CaregiverHireCount totalHires={hiredTimes} />}
        </>
      )}
    </Box>
  );
};
